import { createFileRoute } from '@tanstack/react-router';

import usePersonParams from '@/routes/_staff/person/$id/-hooks/usePersonParams';
import {
  LARGE_CATEGORY_CODES,
  SectionFormWrapper,
  prefetchPeopleLedgerDetail,
} from '@/routes/_staff/person/$id/_profile/-shared';

export const Route = createFileRoute(
  '/_staff/person/alumni/$id/_profile/contractor-information/',
)({
  component: ContractorInformation,
  loader: ({ params }) =>
    prefetchPeopleLedgerDetail(
      params.id,
      LARGE_CATEGORY_CODES.CONTRACTOR_INFORMATION,
    ),
});

const READONLY_SECTION_KEYS: ReadonlySet<string> = new Set([
  'ContractorContract',
  'ContractorCommutingRoute',
]);

function ContractorInformation() {
  const { id } = usePersonParams();

  return (
    <SectionFormWrapper
      personId={id}
      largeCategoryCode={LARGE_CATEGORY_CODES.CONTRACTOR_INFORMATION}
      linkTo="/person/alumni/$id/contractor-information"
      readonlySectionKeys={READONLY_SECTION_KEYS}
    />
  );
}
